import { CASES } from "./constants";

/**
 * Updates window sequence-related state in the Redux store.
 * @param {Object} payload - State properties to merge into the windows slice
 */
export const updateWindows = (payload) => {
  return { type: CASES.UPDATE_WINDOWS, payload };
};

/**
 * Updates a specific field in the windows search form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'filterForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateWindowsSearchForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_WINDOWS_SEARCH_FORM,
    payload: { key, data },
  };
};

/**
 * Updates a specific field in the window sequence create/edit form.
 * @param {Object} params
 * @param {string} params.key - The form state key to update (e.g., 'windowSequenceForm')
 * @param {Object} params.data - The field data to merge into the form
 */
export const updateWindowsForm = ({ key, data }) => {
  return {
    type: CASES.UPDATE_WINDOWS_FORM,
    payload: { key, data },
  };
};

/**
 * Resets the windows state to initial values, preserving sort preference and dropdown options.
 */
export const clearWindows = () => {
  return { type: CASES.CLEAR_WINDOWS, payload: {} };
};

/**
 * Resets the window sequence form and selected sequence to initial values.
 */
export const clearWindowForm = () => {
  return { type: CASES.CLEAR_WINDOW_FORM, payload: {} };
};
